import {
    ALERT_DANGER,
    ALERT_INFO,
    ALERT_SUCCESS,
    ALERT_WARNING
} from "@legacy/helpers/constants/sharedStatics";

export default {
    DANGER: ALERT_DANGER,
    INFO: ALERT_INFO,
    SUCCESS: ALERT_SUCCESS,
    WARNING: ALERT_WARNING
};